import { convert } from '../figlet';

export const banner = async (args?: string[]): Promise<string> => {
  const welcomeMsg = await convert(' Hello World !', 'ANSI Shadow');
  return `
${welcomeMsg}
Type 'help' to see list of available commands.
    `;
};
